export const fetchConfig = async () => {
  try {
    const response = await fetch(`./config.json`);
    const jsonData = await response.json();
    return jsonData;
  } catch (error) {
    console.error("Error fetching config.json:", error);
    return null;
  }
};